Popover = require 'components/common/popover'
QuestionsStatusesActions = require 'actions/questions_statuses_actions'
QuestionStatusForm = require 'components/evidence_syntheses/question/question_status_form'
Translation = require 'components/mixins/translation'
mediator = require 'mediator'
{ kebabCase } = require 'lodash'

{ string, func, node, instanceOf, bool, arrayOf, oneOfType } = PropTypes

ProgressSelect = createReactClass

  displayName: "ProgressSelect"
  mixins: [Translation('es:question.statuses')]

  propTypes:
    afterStatusChange: func
    children: node
    editable: bool
    emptyComponent: node
    groupKey: string
    questionId: string
    questionStatuses: instanceOf(Immutable.Map)
    renderTrigger: func
    showLabel: bool
    statusesList: oneOfType(arrayOf(string), instanceOf(Immutable.List))
    statusModifierPrefix: string
    withCompleted: bool

  getInitialState: ->
    formVisible: false

  getDefaultProps: ->
    afterStatusChange: null
    editable: true
    emptyComponent: null
    questionId: ''
    questionStatuses: Immutable.Map()
    renderTrigger: null
    showLabel: true
    status: ''
    statusModifierPrefix: ''
    withCompleted: true

  toggleCompleted: (e) ->
    QuestionsStatusesActions.toggleQuestionCompleted @props.questionId, e.target.checked
    @toggleForm()

  updateStatus: (key, value) -> =>
    QuestionsStatusesActions.updateQuestionStatus mediator.project.id, @props.questionId, key, value
    .then => @props.afterStatusChange?({key, value})
    @toggleForm()

  toggleForm: ->
    return unless @props.editable
    @setState formVisible: not @state.formVisible

  render: ->
    {
      children
      editable
      emptyComponent
      groupKey
      questionId
      questionStatuses
      renderTrigger
      showLabel
      statusOverride
      statusesList
      statusModifierPrefix
      withClearBtn
      withCompleted
    } = @props

    currentStatus = questionStatuses.get(groupKey, Immutable.Map())
    status = statusOverride or currentStatus.get('status', '')

    boxClassess = classNames 'module-progress__box',
      "module-progress__box--#{kebabCase(status)}"
    statusText = if _.isEmpty(status) then '' else @i18n("status.#{_.string.underscored(status)}")

    return emptyComponent if _.isEmpty(questionId)

    trigger = if renderTrigger
      renderTrigger({ status, toggleForm: @toggleForm })
    else
      <span className={boxClassess} onClick={@toggleForm}>
        {statusText}
      </span>

    <div className='module-progress-select'>
      {showLabel && <span className='bold'>{@i18n 'labels.status'}</span>}
      {if editable
        <Popover
          onRequestClose={@toggleForm}
          visible={@state.formVisible}
        >
          {trigger}
          <QuestionStatusForm
            currentStatus={currentStatus}
            groupKey={groupKey}
            i18n={@i18n}
            status={status}
            statusesList={statusesList}
            statusModifierPrefix={statusModifierPrefix}
            toggleCompleted={@toggleCompleted}
            updateStatus={@updateStatus}
            withCompleted={withCompleted}
          >
            {children}
          </QuestionStatusForm>
        </Popover>
      else
        <div>{trigger}</div>
      }
    </div>

module.exports = ProgressSelect
